import React from 'react';
import { OfferBar } from './components/OfferBar';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PromptExplainer } from './components/PromptExplainer/PromptExplainer';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { ValueStack } from './components/ValueStack';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-full w-full overflow-x-hidden bg-obsidian text-ice" data-id="element-0" data-mp="2wjqhr811w6n6">
      <MetaPixel data-id="element-1" data-mp="28u5x8kp911bs" />
      <OfferBar data-id="element-2" data-mp="28tmfp53igeya" />
      {/* Spacer matching the fixed offer bar height */}
      <div className="h-11" aria-hidden="true" data-id="element-3" data-mp="23vcm2yxfpmes" />
      <main data-id="element-4" data-mp="23ujho4ly78zt">
        <Hero data-id="element-5" data-mp="23v2rsz5cwt3a" />
        <Stats data-id="element-6" data-mp="23ti8y6semyl9" />
        <Testimonials data-id="element-7" data-mp="3ijxsgzk2wgo4" />
        <PainPoints data-id="element-8" data-mp="3ikr0e3urxc7u" />
        <Volumes data-id="element-9" data-mp="3ij65ue8glt9z" />
        <Bonuses data-id="element-10" data-mp="3ijpe138b53at" />
        <Pricing data-id="element-11" data-mp="3ii4qvyobommz" />
        <PromptExplainer data-id="element-12" data-mp="3mlax56bfqdtg" />
        <FAQ data-id="element-13" data-mp="3mkhn9wh6j873" />
        <ValueStack data-id="element-14" data-mp="3mjzsz5e2v41t" />
      </main>
      <Footer data-id="element-15" data-mp="3mj6k9yvk64h1" />
    </div>;
}